import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

//https://github.com/vuetifyjs/vuetify-loader/issues/70

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: '#7aaf71'
            },
            dark: {
                primary: '#7aaf71'
            }
        }
    },
});
